<template>
	<Popper
		v-if="$auth.isAuthenticated.value"
		v-click-outside="closePopover"
		:isVisible="popoverVisible"
		placement="bottom-end"
		@keyup.escape="closePopover"
	>
		<button data-test="account-menu-button" class="popover-trigger" @click="popoverVisible = !popoverVisible">
			<BaseUserAvatar
				:url="$auth.user.value.picture"
				:name="userEmail"
				size="28"
				class="text-xl border border-black"
			/>
			<BaseChevron :flip="popoverVisible" class="ml-4 text-gray-300" />
		</button>
		<template #popup>
			<BasePopover :title="userEmail" data-test="account-menu">
				<button
					class="popover-link text-gray-100"
					data-test="account-settings-button"
					@click="openAccountSettings"
				>
					Account settings
				</button>
				<a
					v-if="!$store.isExtension && browserInfo.platform.type === 'desktop'"
					:href="$env.VUE_APP_EXTENSION_URL"
					data-test="get-extension-link"
					class="popover-link text-gray-100"
					target="_blank"
					@click="onGetExtensionLinkClick"
				>
					Get extension
				</a>
				<button class="popover-link text-gray-100 text-strong-base" @click="toggleTheme">
					{{ $store.theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme' }}
				</button>
				<template #footer>
					<button data-test="logout-button" class="mt-4 popover-link text-gray-100" @click="logout">
						Log out
					</button>
				</template>
			</BasePopover>
		</template>
	</Popper>
</template>

<script>
import Popper from 'shared/components/Popper.vue'
import analytics from 'shared/utils/analytics'
import colorTheme from 'shared/mixins/colorTheme'
import {useBrowserInfo} from 'shared/composables/useBrowserInfo'

export default {
	name: 'MenuAccount',
	components: {
		Popper,
	},
	mixins: [colorTheme],
	setup() {
		return {
			browserInfo: useBrowserInfo(),
		}
	},
	data() {
		return {
			popoverVisible: false,
		}
	},
	computed: {
		userEmail() {
			return this.$auth.user.value.email
		},
	},
	methods: {
		closePopover() {
			this.popoverVisible = false
		},
		openAccountSettings() {
			analytics.track('Settings Button Clicked', {cta: 'Account Menu'})
			this.closePopover()
			this.$routerHelpers.navigateToAccountSettings()
		},
		async logout() {
			analytics.track('Logout Button Clicked')
			this.closePopover()
			await this.$auth.logout()
		},
		onGetExtensionLinkClick() {
			analytics.track('"Get Bird" Button Clicked', {cta: 'Account Menu'})
		},
	},
}
</script>

<style scoped>
.popover-trigger {
	display: inline-flex;
	align-items: center;
	margin-top: 4px;
	height: 28px;
	filter: brightness(90%);
}
.popover-trigger:hover {
	filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5));
}
</style>
